import { documentsAreaCommonSliceActions, downloadDocumentsFile, selectDocumentsAreaCommonState, SignatureDocumentModule, useAppSelector } from 'azshared';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { downloadFile } from '../../../../../utils/utils';

export const SignatureAreaLink = (props: { module?: SignatureDocumentModule; token?: string }) => {
  const { module, token } = props;
  const dispatch = useDispatch();
  const { fileDownloaded, fileDownloadedRequestStatus } = useAppSelector(selectDocumentsAreaCommonState);
  const [isDownloaded, setIsDownloaded] = useState(true);

  const onDownloadDocument = useCallback(() => {
    if (module) {
      dispatch(downloadDocumentsFile({ document: module as any, token }));
      setIsDownloaded(false);
    }
  }, [dispatch, module, token]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onDownloadDocument();
      }
    },
    [onDownloadDocument]
  );

  useEffect(() => {
    if (fileDownloadedRequestStatus === 'succeeded' && fileDownloaded && !isDownloaded) {
      setIsDownloaded(true);
      downloadFile(fileDownloaded.name, fileDownloaded.blob);
      dispatch(documentsAreaCommonSliceActions.clearDownloadFile());
    }
  }, [dispatch, fileDownloadedRequestStatus, fileDownloaded, isDownloaded]);

  if (!module) {
    return null;
  }

  return (
    <a role='button' rel='noopener noreferrer' className='app-link' target='_blank' onClick={onDownloadDocument} onKeyDown={handleKeyDown} tabIndex={0}>
      {module.title}
    </a>
  );
};
